import { Injectable } from '@angular/core';

import { RestService } from "../../../core/services/rest.service";
import { TipoViagem } from "./tipo-viagem.model";
import { apiName } from "./data.service";

@Injectable()
export class TipoViagemApiService {

    constructor(
        private _restService: RestService
    ) { }

    onPost(object: TipoViagem, done: any) {
        this._restService.onPost(apiName, object, done);
    }

    onPut(object: TipoViagem, done: any) {
        this._restService.onPut(apiName, object, done);
    }

    onDelete(objectId: number, done: any) {
        this._restService.onDelete(apiName, objectId, done);
    }

    onGetAll(done: any) {
        let filter: any = {"order":"tipo"};
        this._restService.onGetPost(apiName, filter, done);
    }

    onGetAllActive(done: any) {
        let filter: any = {"where":{"ativo":true},"order":"tipo"};
        this._restService.onGetPost(apiName, filter, done);
    }

    onGetById(objectId: number, done: any) {
        this._restService.onGetPostId(apiName, objectId, {}, done);
    }

    onGetApiUrl() {
        return apiName;
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/tipos-viagem/shared/tipo-viagem-api.service.ts
 **/